import { useQueryClient } from '@tanstack/react-query';
import { UpdateSettingsApiRequest } from '../../../../types/requests/settings/update-settings.request';
import { getSettings, updateSettings } from '../../api/settings.api';
import { useAxiosMutation, useAxiosQuery } from './use-axios.hook';

const baseQueryKey = 'settings';

export const useGetSettings = () => {
  const { data, ...result } = useAxiosQuery({
    queryKey: [baseQueryKey],
    queryFn: async () => (await getSettings()).data,
    staleTime: 1000,
  });
  return { ...result, settings: data } as const;
};

export const useUpdateSettings = () => {
  const queryClient = useQueryClient();
  const [request, { data, ...result }] = useAxiosMutation({
    mutationFn: async (params: UpdateSettingsApiRequest) => (await updateSettings(params)).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [baseQueryKey] }),
  });
  return [request, { ...result, settings: data }] as const;
};
